export default "__VITE_ASSET__BNJn6DSP__"